import React, { useState, useEffect } from 'react';

import validate from '@vlabs/shared/validators';
import { Control, Divider } from '@vlabs/uikit';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CustomFilterPopover } from '../components/CustomFilterPopover';
import { hasAnyError } from '../helpers';
import { useFilterCount } from '../hooks';

export const TopSimilarObjectIdsInputPopover = ({ onCountChange = undefined }) => {
  const { register, formState: { errors }, setValue } = useFormContext();
  const { t } = useTranslation();
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(hasAnyError(errors, 'top_similar_object_ids'));
  }, [errors, errors.top_similar_object_ids]);

  const topSimilarObjectIds = useWatch({ name: 'top_similar_object_ids' });
  const filterCount = topSimilarObjectIds ? 1 : 0;
  useFilterCount('top_similar_object_ids', filterCount, onCountChange);

  return (
    <CustomFilterPopover
      hasError={hasError}
      hasFilterValue={Boolean(filterCount)}
      testId="topSimilarObjectFilter"
      triggerValue={t('id объектов с максимальным результатом сравнения')}
    >
      <Control.Input
        id="top_similar_object_ids"
        label={t('id объектов с максимальным результатом сравнения')}
        {...register('top_similar_object_ids', { validate: validate.multipleUuid() })}
        errors={errors}
      />
      <Divider small />
      <Control.Button
        disabled={filterCount === 0}
        kind="negative"
        onClick={() => setValue('top_similar_object_ids', '')}
        size="small"
        variant="filled"
      >
        {t('button.clear')}
      </Control.Button>
    </CustomFilterPopover>
  );
};
